import { createNotImplementedMethod } from '../utils';
import {
  GetCompletedSurveysRequest,
  GetCompletedSurveysResponse,
  GetCurrentSurveyRequest,
  GetCurrentSurveyResponse,
  GetPendingSurveysRequest,
  GetPendingSurveysResponse,
  GetSurveyDetailRequest,
  GetSurveyDetailResponse,
  SubmitSurveyAnswersRequest,
  SubmitSurveyAnswersResponse,
} from './survey.models';
import {
  GetUserKpiScoresRequest,
  GetUserKpiScoresResponse,
} from './kpi.models';

export interface ISurveyApi {
  getCurrentSurvey(
    request: GetCurrentSurveyRequest
  ): Promise<GetCurrentSurveyResponse>;
  
  getPendingSurveys(
    request: GetPendingSurveysRequest
  ): Promise<GetPendingSurveysResponse>;
  
  getSurveyDetail(
    request: GetSurveyDetailRequest
  ): Promise<GetSurveyDetailResponse>;
  
  submitSurveyAnswers(
    request: SubmitSurveyAnswersRequest
  ): Promise<SubmitSurveyAnswersResponse>;
  
  getCompletedSurveys(
    request: GetCompletedSurveysRequest
  ): Promise<GetCompletedSurveysResponse>;

  getUserKpiScores(
    request: GetUserKpiScoresRequest
  ): Promise<GetUserKpiScoresResponse>;
}

export class NotImplementedSurveyApi implements ISurveyApi {
  public readonly getCurrentSurvey = createNotImplementedMethod();
  public readonly getPendingSurveys = createNotImplementedMethod();
  public readonly getSurveyDetail = createNotImplementedMethod();
  public readonly submitSurveyAnswers = createNotImplementedMethod();
  public readonly getCompletedSurveys = createNotImplementedMethod();
  public readonly getUserKpiScores = createNotImplementedMethod();
}
